'use client';

import { twMerge } from 'tailwind-merge';

export const ZoomControls = ({ zoom, className }: { zoom: any; className?: string }) => {
  return (
    <div className={twMerge('absolute -top-10 -right-2 flex flex-col gap-2', className)}>
      <button
        className="px-2 bg-neutral-800 rounded text-neutral-400 hover:text-neutral-200"
        onClick={() => {
          const next = {
            ...zoom.transformMatrix,
            scaleX: zoom.transformMatrix.scaleX * 1.2,
            scaleY: zoom.transformMatrix.scaleY * 1.2,
          };
          zoom.setTransformMatrix(next);
        }}
      >
        +
      </button>
      <button
        className="px-2 bg-neutral-800 rounded text-neutral-400 hover:text-neutral-200"
        onClick={() => {
          const next = {
            ...zoom.transformMatrix,
            scaleX: zoom.transformMatrix.scaleX * 0.8,
            scaleY: zoom.transformMatrix.scaleY * 0.8,
          };
          zoom.setTransformMatrix(next);
        }}
      >
        -
      </button>
      <button
        className="px-2 py-1 bg-neutral-800 rounded text-neutral-400 hover:text-neutral-200 text-xs"
        onClick={() => {
          zoom.reset();
        }}
      >
        0
      </button>
    </div>
  );
};
